import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { LoginWidgetService } from 'common/widget/login-widget.service';
import { SystemService } from 'common/services/core-services/system.service';
import { LoginModel } from 'common/models/page-models/Login/login/login-data-model';
import { OperationType } from 'common/constants/sm-constants';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { GridParams } from 'common/models/utility-models/list-utility.model';


@Injectable({
    providedIn: 'root'
})
export class LoginResolver extends FormResolverService<LoginModel> {
    constructor(protected ws: LoginWidgetService, protected override router: Router, protected ss: SystemService) {
        super(ws, router, ss);
    }

    override manageState() {
        const currentNav = this.router.getCurrentNavigation();
        const extrasState = currentNav ? currentNav.extras.state : undefined;
    
        if (extrasState === undefined) {
            if(this.systemService.checkLogin()){
                const envelope = new RouteEnvelope();
                envelope.type = OperationType.VIEW;
                envelope.transferData = new GridParams();
                this.systemService.navigateToDashboard()
                return envelope;
            } else {
                 const envelope = new RouteEnvelope();
                 envelope.type = OperationType.CREATE;
                 envelope.transferData = new WidgetModel();
                 this.systemService.navigateToLogin();
                 return envelope;
            }
        } else {
            return extrasState;
        }
    }
}
